import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export const checkInputsForText = <Type>(
  args: Type[],
  formType?: UntypedFormControl | UntypedFormGroup,
): Type[] =>
  args.map((arg, index) => {
    if (typeof arg === 'string') {
      const parsedInput = JSON.parse(arg);

      if (formType && index !== 0) {
        const updatedForm =
          formType instanceof UntypedFormControl
            ? new UntypedFormControl('', [])
            : new UntypedFormGroup({});

        return updatedForm;
      }

      return parsedInput;
    }

    return arg;
  });

export const updateAttributeNestedProperty = <Type>(
  initialObject: Type,
  path: string,
  value: unknown,
): Type => {
  if (!path) return value as Type;

  const keys = path.split('.');
  const updatedObject = Object.entries(initialObject).reduce(
    (newObject, [key, currentValue]) => {
      if (keys[0] === key) {
        newObject[key] =
          keys.length > 1
            ? updateAttributeNestedProperty(
                currentValue,
                keys.slice(1).join('.'),
                value,
              )
            : value;
      } else {
        newObject[key] = currentValue;
      }

      return newObject;
    },
    {},
  );

  return updatedObject as Type;
};
